import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';

import { DateFormatter } from '../../Common/dateFormat';
import PriceFormatter from '../../Common/priceFormatter';
import BalanceCellFormatter from './balanceCellFormatter';
import { isNumber } from '../../Common/NumberUtil';

class EditAPTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rows: [],
      sortColumn: null,
      sortDirection: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.rows !== this.props.rows) {
      const { rows } = nextProps;
      this.setState({ rows });
    }
  }

  getRows = () => Data.Selectors.getRows(this.state);

  getSize = () => this.getRows().length;

  // Grid does not properly re-render when more than one row is updated at a time
  // Problem solved, for more info Refer to link:
  // https://github.com/adazzle/react-data-grid/issues/332
  rowGetter = i => JSON.parse(JSON.stringify(this.getRows()[i]));

  handleGridSort = (sortColumn, sortDirection) => {
    this.setState({
      rows: this.getRows(),
      sortColumn,
      sortDirection,
    });
  }

  handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {
    if (!isNumber(updated.Amount)) {
      return;
    }
    const rows = this.getRows();
    for (let i = fromRow; i <= toRow; i += 1) {
      const rowToUpdate = rows[i];
      const updatedRow = { ...rowToUpdate, ...updated };
      rows[i] = updatedRow;
    }
    this.setState({ rows }, () => { this.props.handlePaymentCellChange(this.state.rows); });
  }

  render() {
    const columns = [
      {
        key: 'ReceiveNum',
        name: <Translate value="receive_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'InvoiceNum',
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'PostingDate',
        name: <Translate value="receive_date" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: 'BillDueDate',
        name: <Translate value="due_date" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: 'FinalPrice',
        name: <Translate value="amount" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: PriceFormatter,
      },
      {
        key: 'Amount',
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        filterable: true,
        editable: true,
        formatter: PriceFormatter,
      },
      {
        key: 'DiscountedAmount',
        name: <Translate value="discount" />,
        resizable: true,
        filterable: true,
        formatter: PriceFormatter,
      },
      {
        key: 'UnpaidAmount',
        name: <Translate value="remaining_balance" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: (
          <BalanceCellFormatter>
            <PriceFormatter />
          </BalanceCellFormatter>
        ),
        getRowMetaData: row => row,
      },
    ];

    return (
      <div style={{ maxWidth: '100%' }} id="editAPTable-dataGrid1">
        <ReactDataGrid
          enableCellSelect
          onGridSort={this.handleGridSort}
          columns={columns}
          rowHeight={25}
          minHeight={350}
          rowGetter={this.rowGetter}
          rowsCount={this.getSize()}
          onGridRowsUpdated={this.handleGridRowsUpdated}
        />
      </div>
    );
  }
}

export default EditAPTable;



// WEBPACK FOOTER //
// ./master/jsx/components/AP/EditAP/editAPTable.jsx